import { BdsTypo } from 'blip-ds/dist/blip-ds-react';
import React, { useContext, useMemo } from 'react';
import DailyEngagedUsersContext from '../../../contexts/DailyEngagedUsersContext';
import { CompiledDailyOverspentAlertRow } from '../styles';

const CompiledDailyEngagedUserOverspentWarningComponent: React.FC = () => {
  const { content, compiledDailyEngagedUserDataState, currentMonth } = useContext(DailyEngagedUsersContext);

  const overspentDauWarningDetails = useMemo(() => {
    if (compiledDailyEngagedUserDataState.showPlanInformations) {
      return content.formatString(
        content.compiledDailyEngagedUserInformation.overspentWarningFeeDetailsWithValues,
        compiledDailyEngagedUserDataState.compiledDailyEngagedUserConsumption.plan.overspentDailyEngagedUserValue.toLocaleString(
          content.locale,
          {
            style: 'currency',
            currency: compiledDailyEngagedUserDataState.compiledDailyEngagedUserConsumption.plan.currencyCode,
          },
        ),
      );
    } else {
      return content.compiledDailyEngagedUserInformation.overspentWarningFeeDetails;
    }
  }, [compiledDailyEngagedUserDataState]);

  return (
    <>
      {compiledDailyEngagedUserDataState.compiledContainsOverspent && (
        <CompiledDailyOverspentAlertRow currentMonth={currentMonth}>
          <div>
            <BdsTypo className="highlighted" tag="p" variant="fs-14" bold="bold">
              {content.compiledDailyEngagedUserInformation.overspentWarningMessage}
              <br />
            </BdsTypo>
            <BdsTypo tag="p" variant="fs-14">
              {overspentDauWarningDetails}
            </BdsTypo>
          </div>
        </CompiledDailyOverspentAlertRow>
      )}
    </>
  );
};

export default CompiledDailyEngagedUserOverspentWarningComponent;
